import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav>
      <ul>
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/induction">Safety Induction</Link>
        </li>
        <li>
          <Link to="/our-history">History</Link>
        </li>
        <li>
          <Link to="/blogs">Blogs</Link>
        </li>
        <li>
          <Link to="/enquiries">Enquiries</Link>
        </li>
        <li>
          <Link to="/links">Links</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
